import { Box, BoxProps } from "@/components/layout/flexbox";
import { Media } from "@/components/layout/Media";
import { CARD_CLASSES } from "@/css/constants";

interface CardAboveXsProps extends BoxProps {
  children: React.ReactNode;
}

export function CardAboveXs({ children, ...boxProps }: CardAboveXsProps) {
  return (
    <>
      <Media at="xs">{children}</Media>
      <Media greaterThan="xs">
        <Box
          py={30}
          px={24}
          backgroundColor="#FFF"
          className={CARD_CLASSES}
          {...boxProps}
        >
          {children}
        </Box>
      </Media>
    </>
  );
}
